import { create } from "zustand";

export type WorkerStatus =
  | "idle"          // ocioso
  | "thinking"      // analisando briefing
  | "typing"        // escrevendo entrega
  | "drawing"       // gerando imagem/vídeo
  | "reviewing"     // revisando trabalho de outro
  | "delivered"     // entregou
  | "blocked";      // travado

export interface WorkerActivity {
  personaId: string;
  status: WorkerStatus;
  taskId?: string;
  taskTitle?: string;
  detail?: string;
  startedAt: number;
}

export interface OpsEvent {
  id: string;
  kind: "task-start" | "task-output" | "task-done" | "stage" | "info";
  text: string;
  personaId?: string;
  taskId?: string;
  at: number;
}

interface OpsState {
  workers: Record<string, WorkerActivity>;
  events: OpsEvent[];
  setWorker: (personaId: string, status: WorkerStatus, opts?: Partial<WorkerActivity>) => void;
  clearWorker: (personaId: string) => void;
  log: (kind: OpsEvent["kind"], text: string, opts?: { personaId?: string; taskId?: string }) => void;
}

const uid = () => "e" + Math.random().toString(36).slice(2, 10);

export const useOps = create<OpsState>((set) => ({
  workers: {},
  events: [],
  setWorker: (personaId, status, opts) => set(s => ({
    workers: {
      ...s.workers,
      [personaId]: {
        ...(s.workers[personaId] ?? { personaId, status: "idle", startedAt: Date.now() }),
        ...opts,
        personaId, status,
        startedAt: opts?.startedAt ?? (s.workers[personaId]?.status === status ? s.workers[personaId].startedAt : Date.now())
      }
    }
  })),
  clearWorker: (personaId) => set(s => {
    const next = { ...s.workers }; delete next[personaId];
    return { workers: next };
  }),
  log: (kind, text, opts) => set(s => ({
    events: [{ id: uid(), kind, text, at: Date.now(), ...opts }, ...s.events].slice(0, 100)
  }))
}));
